import styled from "@emotion/styled";
import { StyledAnimatedSkeleton } from "shared/components/ModuleSkeleton/components/ModuleHeaderSkeleton/styled";

export const SmallSkeleton = styled(StyledAnimatedSkeleton)`
  height: 103px;
  width: 140px;
`;

export const MediumSkeleton = styled(StyledAnimatedSkeleton)`
  height: 127px;
  width: 175px;
`;

export const LargeSkeleton = styled(StyledAnimatedSkeleton)`
  height: 148px;
  width: 273px;
`;
